import { Component, Input, OnInit } from '@angular/core';
import { ChartDataSets } from 'chart.js';
import { LineChartColors } from 'src/app/shared/model/chart';

@Component({
  selector: 'app-device-bandwidth',
  templateUrl: './device-bandwidth.component.html',
  styleUrls: ['./device-bandwidth.component.scss']
})
export class DeviceBandwidthComponent implements OnInit {
  @Input() registeredLinks: string[];

  @Input() set bandData(v_arr) {
    this.lineChartLabels = [];
    this.lineChartData = [];
    if (!v_arr || !v_arr.length) return;

    // Priority sort order
    const priorityOrder = ["link1", "link2", "link3", "linkB1"];

    // Sort original registered links
    this.registeredLinks = (this.registeredLinks || []).sort((a, b) => {
      const ia = priorityOrder.indexOf(a);
      const ib = priorityOrder.indexOf(b);

      if (ia !== -1 && ib !== -1) return ia - ib;
      if (ia !== -1) return -1;
      if (ib !== -1) return 1;

      return +a.replace("link", "") - +b.replace("link", "");
    });

    // Get API detected links
    const firstRow = v_arr[0];
    const payloadLinks = Object.keys(firstRow)
      .filter(k => k.includes("Bandwidth"))
      .map(k => k.replace(" Bandwidth", ""));

    // Combined unique links
    const allLinks = [...new Set([...(this.registeredLinks || []), ...payloadLinks])];

    // Fill missing BW fields with 0
    v_arr.forEach(row => {
      allLinks.forEach(link => {
        const k = `${link} Bandwidth`;
        if (row[k] == null) row[k] = 0;
      });
    });

    // Build chart series
    Object.keys(v_arr[0]).forEach(key => {
      if (key.includes("Bandwidth")) {
        const data = [];
        this.lineChartLabels = [];

        v_arr.forEach(entry => {
          data.push(entry[key] || 0);
          this.lineChartLabels.push(entry.datetime);
        });

        this.lineChartData.push({
          data,
          label: key.replace(" Bandwidth", "")
        });
      }
    });

    // ✅ Sort chart lines by registeredLinks order
    this.lineChartData.sort((a, b) => {
      const order = this.registeredLinks || [];
      const ia = order.indexOf(a.label);
      const ib = order.indexOf(b.label);

      if (ia !== -1 && ib !== -1) return ia - ib;
      if (ia !== -1) return -1;
      if (ib !== -1) return 1;

      return +a.label.replace("link", "") - +b.label.replace("link", "");
    });
  }

  @Input() large: any;

  public lineChartData: ChartDataSets[] = [];
  public lineChartLabels: any = [];
  public lineChartOptions = {
    responsive: true,
    scales: {
      yAxes: [{
        display: true,
        scaleLabel: { display: true, labelString: 'Mbps' },
        ticks: { beginAtZero: true }
      }]
    }
  };
  public lineChartColors = LineChartColors;
  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [];

  constructor() {}
  ngOnInit(): void {}
}
